import { BsPinterest, BsTwitter, BsWhatsapp } from "react-icons/bs";
import { BiLogoFacebook, BiLogoLinkedin } from "react-icons/bi";
import style from "@/styles/Quill.module.css";

const SingleBlogContent = ({ blogData }) => {
  const blogURL =
    process.env.NEXT_PUBLIC_API_URL === "https://api.shaadivines.com"
      ? `https://www.invitedekho.com/blog/${blogData?.slug}`
      : ` https://stage.invitedekho.com/blog/${blogData?.slug}`;

  const shareBtn = [
    {
      icon: <BsTwitter size={15} />,
      link: `https://twitter.com/intent/tweet?text=${encodeURIComponent(
        blogData?.content?.title
      )}&url=${encodeURIComponent(blogURL)}`,
    },
    {
      icon: <BiLogoFacebook size={15} />,
      link: `https://www.facebook.com/sharer.php?u=${encodeURIComponent(
        blogURL
      )}`,
    },
    {
      icon: <BiLogoLinkedin size={15} />,
      link: `https://www.linkedin.com/shareArticle?url=${encodeURIComponent(
        blogURL
      )}`,
    },
    {
      icon: <BsPinterest size={15} />,
      link: `https://pinterest.com/pin/create/button/?url=${encodeURIComponent(
        blogURL
      )}`,
    },
    {
      icon: <BsWhatsapp size={15} />,
      link: `whatsapp://send?text=${encodeURIComponent(blogURL)}`,
    },
  ];

  return (
    <div className="grid grid-cols-12 lg:gap-10 gap-4 lg:my-20 my-6">
      <div className="lg:col-span-1 col-span-12 text-center lg:order-1 order-2">
        <div className="lg:sticky flex flex-col items-start lg:top-[100px] top-0">
          <span className="text-base text-[#212529] pt-4">Share</span>
          <ul className=" flex lg:flex-col flex-row lg:items-center lg:justify-center lg:gap-0 gap-2">
            {shareBtn.map((item, index) => {
              return (
                <li key={index}>
                  <a
                    href={item.link}
                    target="_blank"
                    className="text-[#21252960] lg:mt-4 mt-2 border-[1px] p-2 border-[#21252960] rounded-[100%] h-[40px] w-[40px]
              flex items-center justify-center"
                    rel="noreferrer"
                    aria-label="Share">
                    {item.icon}
                  </a>
                </li>
              );
            })}
          </ul>
        </div>
      </div>
      <div className="lg:col-span-11 col-span-12 lg:order-2 order-1">
        <div
          className={style.blogContent}
          id="mainContent"
          // style={{fontFamily:"Outfit"}}
          dangerouslySetInnerHTML={{
            __html: blogData?.content?.mainContent,
          }}
        />
      </div>
    </div>
  );
};

export default SingleBlogContent;
// new QuillDeltaToHtmlConverter(
//   blogData?.content?.mainContent.ops,
//   {}
// ).convert(),
